export default function () {
    return (
        <svg width="32" height="33" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M7.73438 23.0996H20.2656C20.9187 23.0997 21.4783 23.5503 21.627 24.1748L21.6514 24.3018L22.0801 27.3018C22.2005 28.145 21.5461 28.9002 20.6943 28.9004H7.30566C6.50713 28.9002 5.88202 28.2367 5.90625 27.459L5.91992 27.3018L6.34863 24.3018C6.44726 23.6122 7.03784 23.0997 7.73438 23.0996Z"
                stroke="black"
                strokeWidth="1.2"
            />
            <path
                d="M8.1084 5.09961H19.8916C20.6435 5.09961 21.2516 5.69102 21.29 6.4248V6.57324L20.501 21.5732C20.4618 22.3168 19.8471 22.9004 19.1025 22.9004H8.89746C8.1994 22.9004 7.61612 22.3877 7.51367 21.7109L7.49902 21.5732L6.70996 6.57324C6.668 5.77239 7.3064 5.09961 8.1084 5.09961Z"
                stroke="black"
                strokeWidth="1.2"
            />
            <path
                d="M22.5 8.49998V9.09998H22.5426L22.5849 9.09395L22.5 8.49998ZM25.4 18.5C25.4 18.8314 25.6686 19.1 26 19.1C26.3314 19.1 26.6 18.8314 26.6 18.5H25.4ZM6.5 8.49998V9.09998H22.5V8.49998V7.89998H6.5V8.49998ZM22.5 8.49998L22.5849 9.09395C23.0952 9.02104 23.8415 9.05028 24.4304 9.32959C24.7155 9.46484 24.9505 9.65191 25.1161 9.90338C25.2802 10.1526 25.4 10.501 25.4 11H26H26.6C26.6 10.2989 26.4282 9.71404 26.1183 9.24344C25.8099 8.77512 25.3886 8.45595 24.9446 8.24536C24.0752 7.833 23.0715 7.81224 22.4151 7.90601L22.5 8.49998ZM26 11H25.4V18.5H26H26.6V11H26Z"
                fill="black"
            />
            <path
                d="M12.5 14.1C12.8314 14.1 13.1 13.8314 13.1 13.5C13.1 13.1686 12.8314 12.9 12.5 12.9V14.1ZM12.5 13.5V12.9H7V13.5V14.1H12.5V13.5Z"
                fill="black"
            />
            <path d="M12 18.1C12.3314 18.1 12.6 17.8314 12.6 17.5C12.6 17.1686 12.3314 16.9 12 16.9V18.1ZM12 17.5V16.9H7.5V17.5V18.1H12V17.5Z" fill="black" />
        </svg>
    );
}
